import React, { useRef, useState } from 'react';

const FloatingLabelInput = ({ label, value, onChange }) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  const handleFocus = () => {
    setIsFocused(true);
    inputRef.current.focus();
  }

  return (
    <div className="relative w-full">
      <label
        className={`absolute left-3 top-1/2 transform -translate-y-1/2 transition-all duration-300 text-white z-1
        ${isFocused || value ? 'text-base top-[-1px]  bg-tertiary ' : 'text-base'}`}
        onClick={() => !isFocused && handleFocus()}
      >
        {label}
      </label>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className="p-3 w-full rounded-md bg-tertiary border border-gray-700 text-white focus:outline-none placeholder-transparent z-2"
        placeholder="Name"
      />
    </div>
  );
};

export default FloatingLabelInput;
